export const defFont='SpoqaHanSansNeo-Medium';
export const defTxtFont='SpoqaHanSansNeo-Light';//'Courier New';
export const defBtnFont='SpoqaHanSansNeo-Medium';

export const slotHeight=48;
export const defSlotHeight=48;
export const defSummitBtnHeight=60;
export const defFieldMarginBttom=25;
